import React from 'react';

// ART-WER one-pager: flat anchor navigation to the on-page sections.
const MenuItems = () => {
    return (
        <React.Fragment>
            <li><a href="#home">Home</a></li>
            <li><a href="#diensten">Diensten</a></li>
            <li><a href="#over">Over ons</a></li>
            <li><a href="#werkwijze">Werkwijze</a></li>
            <li><a href="#projecten">Projecten</a></li>
            <li><a href="#contact">Contact</a></li>
        </React.Fragment>
    );
}

export default MenuItems;
